import { render, staticRenderFns } from "./LogItem.vue?vue&type=template&id=71be2d70&scoped=true&"
import script from "./LogItem.vue?vue&type=script&lang=js&"
export * from "./LogItem.vue?vue&type=script&lang=js&"
import style0 from "./LogItem.vue?vue&type=style&index=0&id=71be2d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be2d70",
  null
  
)

export default component.exports